import ComingSoon from "../components/ComingSoon";

const Upgrades = () => <ComingSoon title="Upgrades" />;
export default Upgrades;
